import type { TreeMapFilterType, TreeMapStats } from "../tree-map.type";

/**
 * See rules from "_Règles d'affaire carte d'un arbre.xlsx_" in Sharepoint
 */
export const hideTreeFilterCardSubFilters = (
  type: TreeMapFilterType,
  { hasGeojson }: TreeMapStats
) => {
  return type === "location" ? !hasGeojson : false;
};

/**
 * See rules from "_Règles d'affaire carte d'un arbre.xlsx_" in Sharepoint
 */
export const showTreeMapFilterCardArrow = (
  type: TreeMapFilterType,
  { hasLocations, hasSectors, hasAssets, hasGeojson }: TreeMapStats
): boolean => {
  if (type === "location") {
    return hasGeojson && hasAssets;
  }

  if (type === "asset") {
    return hasLocations && !hasSectors && !hasGeojson ? false : true;
  }

  return true;
};

export const getTreeMapFilterCardTitleType = (
  type: TreeMapFilterType,
  { hasLocations, hasSectors }: TreeMapStats
): string => {
  if (type !== "location") return type;

  // For location, let's handle "location/sector"
  if (hasLocations && hasSectors) return "locationSector";
  if (hasSectors) return "sector";
  return "location";
};
